import { createStructuredSelector } from "reselect";

export const financialStatementScreenFixesSelector = createStructuredSelector({
  category: (state) => state.financialStatementScreens.fixes.category,
  period: (state) => state.financialStatementScreens.fixes.period,
  unit: (state) => state.financialStatementScreens.fixes.unit,
  structure: (state) => state.financialStatementScreens.fixes.structure,
});
